<h1>Ügyindítások</h1>

@if (loading()) {
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
  ></mat-progress-spinner>
}

@if (!loading()) {
  <div class="flex case-starts-chart-container">
    <div style="width: 800px; height: 400px"><canvas #casesStarted></canvas></div>
    <div>
      <payee-info>A grafikon-on a negatív értékek az elutasított ügyeket jelentik.</payee-info>
      @for (entry of casesStartedDataSums | keyvalue; track entry.key) {
        <div>
          <strong>{{ entry.key }}:</strong>
          <span>{{ entry.value }}</span>
        </div>
      }
    </div>
  </div>
}
